import { render, staticRenderFns } from "./ProjectDetailsCard.vue?vue&type=template&id=1d9560b2&scoped=true"
import script from "./ProjectDetailsCard.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailsCard.vue?vue&type=style&index=0&id=1d9560b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9560b2",
  null
  
)

export default component.exports